import React from 'react'
const CourseTabInvalidStateError = (): JSX.Element => {
  return (
    <div data-testid='course-tab-invalid-state-content'>
      CourseTabInvalidStateError
    </div>
  )
}

export default CourseTabInvalidStateError
